module.exports = __webpack_public_path__ + "static/img/banner-page.86ba974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NewcomerSignIn/banner-page.png
// module id = +lv6
// module chunks = 0